import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { GoogleOAuthProvider } from '@react-oauth/google'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'

// ── Sentry 监控（替换下面的 DSN 为你的项目地址）────────────────────────────
// 获取方式：sentry.io → 创建项目 → Settings → Client Keys (DSN)
// 格式：https://<key>@o<orgId>.ingest.sentry.io/<projectId>
Sentry.init({
  dsn: 'https://fded820b278bc85fc70ac86a42693574@o4511352116543488.ingest.us.sentry.io/4511352125063168',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // 采样率：1.0 = 100% 用户session，适合免费版
  tracesSampleRate: 1.0,
  // replay 采样（用户体验录制）
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

const GOOGLE_CLIENT_ID =
  "871603704767-18enjm7ns128g4tebu1jltmlj8i66v06.apps.googleusercontent.com";

// Hide static SSR nav once React Navbar mounts into #root
(function hideSsrNav() {
  const ssrNav = document.getElementById('ssr-nav');
  if (!ssrNav) return;

  const observer = new MutationObserver(() => {
    const root = document.getElementById('root');
    if (!root) return;
    // React Navbar is a <nav> with sticky class inside #root
    const reactNav = root.querySelector('nav.sticky');
    if (reactNav) {
      ssrNav.style.display = 'none';
      observer.disconnect();
    }
  });

  observer.observe(document.getElementById('root'), { childList: true, subtree: true });
  // Fallback: hide after 3s regardless (React nav may already be there on SPA revisit)
  setTimeout(() => { if (ssrNav) ssrNav.style.display = 'none'; }, 3000);
})();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </StrictMode>,
)
